<script setup lang="ts">
import { getNetworkIdFromString } from '@sonarwatch/portfolio-core';
import { networkDarkLogos, networkLightLogos } from '@/constants';
import { computed } from 'vue';
import { useAppStore } from '@/store/app';
const store = useAppStore();
const props = defineProps({
  size: { type: [Number, String], default: 16 },
  networkId: { type: String, required: true },
  opacity: { type: Number, default: 1 },
});

const fNetworkId = getNetworkIdFromString(props.networkId);
const image = computed(() => {
  if (!fNetworkId) return null;
  return store.isDark
    ? networkLightLogos[fNetworkId]
    : networkDarkLogos[fNetworkId];
});
</script>

<template>
  <v-avatar
    v-if="image"
    :size="size"
    :image="image"
    rounded="0"
    :style="{ opacity: opacity }"
  />
</template>
